import { axiosGet, axiosPost, axiosPostWithFile } from './apiClient';
const base = `${process.env.REACT_APP_BASE_URL}/product-groups`;
async function data(request) {
  const result = await request;
  if (result.status === 'FAIL') throw new Error(result.message || 'Product group request failed');
  return result.data;
}
const productGroupApi = {
  list: params => data(axiosGet(base, params)),
  detail: id => data(axiosGet(`${base}/${id}`)),
  lookup: (search, mode) => data(axiosGet(`${base}/lookup`,{search,mode})),
  save: body => data(axiosPost(`${base}/save`, body)),
  remove: id => data(axiosPost(`${base}/${id}/delete`)),
  upload: file => {const form = new FormData(); form.append('banner',file); return data(axiosPostWithFile(`${base}/banner`,form));}
};
export default productGroupApi;
